import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { EDITORIAL_CONTENT_NODE_ID } from '../../../constants';
import { componentIsInViewport, throttle } from '../../../utils/dom';
import {
  sendGASlideViewEvents,
  sendDataLayerSlideViewEvent
} from '../../../utils/analytics';
import IntroSlide from './intro_slide';
import withScrollDepthTracking from '../../hocs/withScrollDepthTracking';
import Sections from '../../section/sections';
import TrinityAudioPlayer from '../../common/trinityAudioPlayer';

const INTRO_SLIDE_IDX = 0;
const HANDLE_SCROLL_THROTTLE_MS = 500;

export class NonDesktopLayout extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleScroll = throttle(
      this.handleScroll.bind(this),
      this.props.throttleWait
    );
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (componentIsInViewport(this._node, window)) {
      sendGASlideViewEvents(INTRO_SLIDE_IDX);
      sendDataLayerSlideViewEvent(INTRO_SLIDE_IDX);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  render() {
    const { bodySections, openerImage, sectionsProps, slideIndex,
      socialIconProps, slideshowSections, relatedEntries } = this.props;

    /*
     *  "body-sections" Sections component:
     *    * Should not send SectionView events, because we want to count
     *      a visible Intro Opener Image as a SectionView event.
     *      Instead, we handle the event in *this* component, with section
     *      index 0.
     *    * Should not send scroll depth events. Instead, we handle overall
     *      scroll depth including the slideshow-sections in *this* component.
     *
     *  "slide-sections" Sections component:
     *    * Should send SectionView events for section indices 1 - slideCount.
     *    * Should not send scroll depth events. Instead, we handle overall
     *      scroll depth including the body-sections in *this* component.
     */
    const bodySectionsShouldSendGAViewEvents = false;
    const bodySectionsShouldSendScrollDepthEvents = false;
    const slideSectionsShouldSendGAViewEvents = true;
    const slideSectionsShouldSendScrollDepthEvents = false;

    const introSlide = (
      openerImage
        ? (
          <IntroSlide openerImage={openerImage}
            socialIconProps={socialIconProps}
          />
        )
        : null
    );

    return (
      <div className="non-desktop-layout" id={EDITORIAL_CONTENT_NODE_ID}>
        <TrinityAudioPlayer />
        <div className="intro-slide-container" ref={node => this._node = node}>
          {introSlide}
          <div className="body-sections">
            <Sections {...sectionsProps}
              sections={bodySections}
              shouldSendGAViewEvents={bodySectionsShouldSendGAViewEvents}
              shouldSendGAScrollDepthEvents={
                bodySectionsShouldSendScrollDepthEvents
              }
            />
          </div>
        </div>
        <div className="slide-sections">
          <Sections {...sectionsProps}
            sections={slideshowSections}
            slideIndex={slideIndex}
            renderAsMobileSlideSections
            shouldSendGAViewEvents={slideSectionsShouldSendGAViewEvents}
            shouldSendGAScrollDepthEvents={
              slideSectionsShouldSendScrollDepthEvents
            }
            relatedEntries={relatedEntries}
          />
        </div>
      </div>
    );
  }
}

export default withScrollDepthTracking({
  shouldTrackScrollEvent: () => true
})(NonDesktopLayout);

NonDesktopLayout.propTypes = {
  bodySections: PropTypes.arrayOf(PropTypes.object).isRequired,
  openerImage: PropTypes.object,
  sectionsProps: PropTypes.object.isRequired,
  slideIndex: PropTypes.number.isRequired,
  slideshowSections: PropTypes.arrayOf(PropTypes.object).isRequired,
  socialIconProps: PropTypes.object.isRequired,
  throttleWait: PropTypes.number.isRequired,
  relatedEntries: PropTypes.array
};

NonDesktopLayout.defaultProps = {
  throttleWait: HANDLE_SCROLL_THROTTLE_MS
};
